import { UseMutationResult, useQuery } from "@tanstack/react-query";
import { Button, Card, Input } from "@rumbledirect/ui";
import { Form, Select } from "antd";
import { DocumentLibraryInput } from "../../../../lib/api/resources/documentLibraries";
import { fetchAiProfiles } from "../../../../lib/api/resources/agents";
import { DocumentLibrary } from "@rumble-it/common-lib/types/models/DocumentLibrary.interface";

interface DocumentLibraryFormCardProps {
  mutation: UseMutationResult<
    DocumentLibrary,
    Error,
    DocumentLibraryInput,
    unknown
  >;
  title?: string;
  buttonText?: string;
}

export const DocumentLibraryFormCard = ({
  mutation,
  title = "Bibliotheek aanmaken",
  buttonText = "Aanmaken",
}: DocumentLibraryFormCardProps) => {
  const [form] = Form.useForm();

  const { data: aiProfiles } = useQuery({
    queryKey: ["ai_profiles"],
    queryFn: fetchAiProfiles,
  });

  const aiProfileOptions = (aiProfiles?.member ?? []).map((profile) => ({
    label: profile.name,
    value: profile.id,
  }));

  const handleFinish = (values: DocumentLibraryInput) => {
    mutation.mutate(values);
  };

  return (
    <Form form={form} onFinish={handleFinish} layout="vertical">
      <Card title={title}>
        <Form.Item
          rules={[{ required: true, message: "Dit veld is verplicht" }]}
          label="Naam"
          name="name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          rules={[{ required: true, message: "Dit veld is verplicht" }]}
          label="AI-profiel (embeddings)"
          name="aiProfile"
        >
          <Select options={aiProfileOptions} />
        </Form.Item>
        <Form.Item label={null}>
          <Button loading={mutation.isPending} type="primary" htmlType="submit">
            {buttonText}
          </Button>
        </Form.Item>
      </Card>
    </Form>
  );
};
